// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"6738297a","187":"15e36604","239":"50a2d852","394":"6a08f9d5","455":"ad97a4dd","977":"89a835c4","998":"38064eb2"}[chunkId] + ".chunk.js";
};